import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../../redux/user/action";
import { addadmin } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import UploadImage from "../Category/UploadImage";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../Firebase/Config";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import * as yup from "yup";

const uniqueId1 = uuidv4();
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-])|(\\([0-9]{2,3}\\)[ \\-])|([0-9]{2,4})[ \\-])?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },
  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email Address (Optional)", name: "email_id" },
  // { title: "Gender", name: "gender" },
  { title: "Status", name: "status" },
];

const initialValues = formData.reduce((acc, field) => {
  acc[field.name] = field.name === "status" ? 1 : "";
  return acc;
}, {});
// console.log(initialValues, "initialValues");

console.log(initialValues, "ini");

const Addadmin = ({ data }) => {
  const addadmins = (update) =>
    yup.object({
      first_name: yup
        .string()
        .matches(/^[A-Za-z]+$/, "Only alphabets are allowed") 
        .required("This field is required")
        .min(2, "Enter at least two characters")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim().length > 0
        ),

        last_name: yup
        .string()
        .matches(/^[A-Za-z]+$/, "Only alphabets are allowed") 
        .required("This field is required")
        .min(2, "Enter at least two characters")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value && value.trim().length > 0
        ),
      mobile_number: yup
        .string()
        .min(9, "minimum number")
        .max(10, "Maximum of 10 number you can use")
        .required("mobile number is required"),

      // gender: yup
      //   .number()
      //   .required("Gender is required")
      //   .oneOf([1, 2, 3], "Invalid gender value"),
      status: yup
        .number()
        .oneOf(
          [1, 2, 3],
          "Status must be 1 (Active), 2 (Inactive), 3 (Blocked)"
        )
        .required("This field is required"),
      email_id: yup
        .string()
        .email("Enter a valid email address")
        .test(
          "optional-email-validation",
          "Enter a valid email address",
          (value) =>
            !value ||
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
        ),
    });

  const { t } = useTranslation();
  const [gender, setGender] = useState(1);
  const [profileimage, setProfileimage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);
  const dispatch = useDispatch();
  const selectedUser = useSelector(({ admin: { editUser } }) => editUser);
  let one;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (value) => handleSubmit(value),
    validationSchema: addadmins(update),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handleSubmit = async (values) => {
    if (Object.keys(formik.errors).length > 0) {
      return;
    }

    try {
      setLoading(true);
      const storage = getStorage(fireStore);

      const uploadImage = async (file, path) => {
        if (file) {
          const imageRef = ref(storage, path);
          const uploadTask = uploadBytesResumable(imageRef, file);
          const snapshot = await uploadTask;
          return await getDownloadURL(snapshot.ref);
        }
        return "";
      };

      let maleImageUrl = "";
      if (profileimage) {
        maleImageUrl = await uploadImage(
          profileimage,
          `/Category/${uniqueId1}_male_${profileimage.name}`
        );
      }

      const data = {
        ...values,
        // profile_image: maleImageUrl,
      };

      dispatch(addUser(data, setLoading, navigate));
      setUpdate(false);
    } catch (err) {
      swal({
        text: err.message || "An error occurred while submitting the form",
        icon: "error",
        button: t("Close"),
        timer: 1500,
      });
      setLoading(false);
    }
  };
  console.log(formik.errors, "may");
  const navigate = useNavigate();
  return (
    <Card className="card-head order-timing">
  
      <CardBody className="">
      <AddUpdateHeader modal={"Add Customer"} list={"User List"} />
        <form onSubmit={formik.handleSubmit}>
          <Row className=" ">
            {formData.map((prop, key) => {
              if (prop.name === "mobile_number") {
                return (
                  <div className=" col-md-4 " key={key} >
                    <div className="form-group">
                      <label htmlFor={prop.name}>{t(prop.title)}</label>
                      <PhoneInput
                        country={"sa"}
                        value={
                          formik?.values.country_code
                            ? `${formik.values.country_code}${formik.values.mobile_number}`
                            : ""
                        }
                        onChange={(phone, data) =>
                          handleCountryCode(phone, data)
                        }
                        onBlur={() => formik.setFieldTouched(prop.name, true)}
                      />
                    </div>
                    {formik.touched.mobile_number &&
                      formik.errors.mobile_number && (
                        <p style={{ color: "red" }}>
                          {formik.errors.mobile_number}
                        </p>
                      )}
                  </div>
                );
              }
              if (prop.name === "status") {
                const options = [
                  { value: "1", label: t("Active") },
                  { value: "2", label: t("Inactive") },
                  { value: "3", label: t("Block") },
                ];

                return (
                  <div className="col-md-4  form-group" key={key} >
                    <label>{t(prop.title)}</label>
                    <div>
                      <ReactSelect
                        // className='form-control'
                        value={options.find(
                          (option) => option.value == formik.values?.[prop.name]
                        )}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(selectedOption) =>
                          formik.handleChange(prop.name)(selectedOption.value)
                        }
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.status && formik.errors.status && (
                        <p style={{ color: "red" }}>{formik.errors.status}</p>
                      )}
                    </div>
                  </div>
                );
              }

              if (prop.name === "password") {
                return (
                  <div className=" col-md-4 " key={key} >
                    <div className="form-group">
                      <label>Password</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                      {formik.touched.password && formik.errors.password && (
                        <p style={{ color: "red" }}>{formik.errors.password}</p>
                      )}
                    </div>
                  </div>
                );
              }
              if (prop.name === "email_id") {
                return (
                  <div className=" col-md-4 " key={key} >
                    <div className="form-group">
                      <label>{prop.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />

                      {formik.values.email_id &&
                        formik.touched.email_id &&
                        formik.errors.email_id && (
                          <p style={{ color: "red" }}>
                            {formik.errors.email_id}
                          </p>
                        )}
                    </div>
                  </div>
                );
              }

              if (prop.name === "profile_image") {
                return (
                  <>
                    <UploadImage
                      files={profileimage}
                      setFiles={setProfileimage}
                      update={update}
                      prop={prop}
                      formik={formik}
                    />
                    <div></div>
                  </>
                );
              }
              // if (prop.name === "gender") {
              //   const options = [
              //     { value: 1, label: t("Male") },
              //     { value: 2, label: t("Female") },
              //     // { value: 3, label: t("Both") },
              //   ];

              //   return (
              //     <Col key={key} xs={4}>
              //       <label>{t(prop.title)}</label>
              //       <div>
              //         <ReactSelect
              //           value={options.find(
              //             (option) => option.value == formik.values?.[prop.name]
              //           )}
              //           placeholder={t(prop.title)}
              //           id={prop.name}
              //           name={prop.name}
              //           options={options}
              //           onChange={(option) => {
              //             formik.setFieldValue("gender", option?.value);
              //             setGender(option?.value);
              //           }}
              //           onBlur={formik.handleBlur}
              //         />
              //         {formik.touched.gender && formik.errors.gender && (
              //           <p style={{ color: "red" }}>{formik.errors.gender}</p>
              //         )}
              //       </div>
              //     </Col>
              //   );
              // }
              if (prop.name === "dob") {
                return (
                  <div className="col-md-4 " key={key} >
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                        type="date"
                      />
                      {formik.touched.dob && formik.errors.dob && (
                        <p style={{ color: "red" }}>{formik.errors.dob}</p>
                      )}
                    </div>
                  </div>
                );
              }
              return (
                <div className=" col-md-4 " key={key} >
                  <div className="form-group">
                    <label>{prop?.title}</label>
                    <CustomInput
                      value={formik.values?.[prop.name]}
                      placeholder={t(prop.title)}
                      id={prop.name}
                      name={prop.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    />
                    {formik.touched[prop.name] && formik.errors[prop.name] && (
                      <p style={{ color: "red" }}>
                        {t(formik.errors[prop.name])}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
            <Col
              md={12}
              className="text-center my-3 d-flex align-items-center justify-content-between"
            >
              <button
                className="back-btn"
                disabled={loading}
                onClick={() => navigate("/user")}
                type="submit"
              >
                Back
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="submit-btn"
                disabled={loading}
                type="submit"
              >
                {!loading ? "Submit" : <Spinner />}
              </button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
};

export default Addadmin;
